// (B) message host — antd message 파리티 커스텀 렌더러(sonner 미사용). KitThemeHost 가 realm 별 1개 마운트.
// DOM 구조(antd 미러링):
//   .om-message(container: fixed top-center, pointer-events:none)
//     └ .om-message-notice-wrapper(간격 = padding, grid-rows 로 enter/leave collapse)
//         └ .om-message-notice-inner(overflow:hidden)
//             └ .om-message-notice(실제 pill: 아이콘 + 내용, pointer-events:auto)
// block flow 라 배열 순서(append=최신 아래)가 그대로 위→아래로 표시된다(§omMessage.css).
import { useState, useEffect, useSyncExternalStore } from 'react'
import { messageStore, type OmMessageItem } from './messageStore'
import { toastIcons } from './toastIcons'
import '../styles/omwMessage.css'

// SSR/초기 스냅샷용 안정 참조(useSyncExternalStore 가 매번 새 배열을 만들지 않도록 상수).
const EMPTY: OmMessageItem[] = []
function getServerSnapshot(): OmMessageItem[] {
  return EMPTY
}

function MessageNotice({ item }: { item: OmMessageItem }): React.ReactElement {
  // 마운트 직후 open 으로 전환 → grid-rows 0fr→1fr, opacity/translate 진입 애니메이션.
  const [entered, setEntered] = useState(false)
  useEffect(() => {
    const raf = requestAnimationFrame(() => setEntered(true))
    return () => cancelAnimationFrame(raf)
  }, [])

  const open = entered && !item.closing

  return (
    <div className="om-message-notice-wrapper" data-open={open}>
      <div className="om-message-notice-inner">
        <div className={`om-message-notice om-message-notice-${item.kind}`}>
          <span className="om-message-icon">{toastIcons[item.kind]}</span>
          <span className="om-message-content">{item.content}</span>
        </div>
      </div>
    </div>
  )
}

export function OmwMessageHost(): React.ReactElement | null {
  const items = useSyncExternalStore(
    messageStore.subscribe,
    messageStore.getSnapshot,
    getServerSnapshot,
  )

  if (items.length === 0) return null

  return (
    <div className="om-message om-message-top">
      {items.map((item) => (
        <MessageNotice key={item.id} item={item} />
      ))}
    </div>
  )
}
